export const getValidPreviousIntentId = (
  intentIndex: number,
  inputJson: any[],
  applicationInput: any[]
) => {
  for (let i = intentIndex - 1; i >= 0; i--) {
    const previousIntent = inputJson[i]

    if (applicationInput?.some((input: any) => input.id === previousIntent.id)) {
      return previousIntent.id
    }
  }
  return null
}
